import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationApiService {
  constructor(private http: HttpClient) {}

  login(email: string, password: string) {
    return this.http
      .post(`/api/authenticate`, {
        email,
        password
      })
      .toPromise();
  }

  public fetchCurrentUser(): Promise<any> {
    return this.http.get(`/api/authenticate/me`).toPromise();
  }

  public updateCurrentUser( user : any ) {
    return this.http.put(`/api/authenticate/me`, user).toPromise();
  }

  public forgotPassword(email: string) {
    return this.http.post(`/api/authenticate/forgot-password`, { email }).toPromise();
  }



}
